import React from 'react'
import styled from 'styled-components'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import { useTranslation } from 'react-i18next'

interface FooterProps {
  data?: any
  type?: 'sip' | 'kontrak' | 'so'
}

const custSectorType: any = {
  Z2: 'Kebun',
  Z3: 'Industri',
  Z4: 'Export',
  Z6: 'Retail - CCM',
}

const StyledProne = styled.div`
  p {
    margin-bottom: 1rem !important;
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
`
const StyledProneMbNo = styled.div`
  p {
    margin-bottom: 0 !important;
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
`

export const Footer: React.FC<FooterProps> = (props) => {
  const htmlString =
    props.data.lang == 'en' ? props.data.footerContentEn : props.data.footerContentId

  const createMarkup = () => {
    return {__html: htmlString}
  }

  const createMarkup2 = () => {
    return {__html: props.data?.configletter}
  }

  const dateFrom = props.data?.dateFrom ? new Date(props.data?.dateFrom).toLocaleDateString((props.data?.lang == 'en' ? 'en-EN' : 'id-ID'), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }) : ''

  const dateTo = props.data?.dateTo ? new Date(props.data?.dateTo).toLocaleDateString((props.data?.lang == 'en' ? 'en-EN' : 'id-ID'), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }) : ''

  const validDate = () => {
    let _dt = props.data?.batasTanggal ? new Date(props.data?.batasTanggal) : new Date();
    return _dt.toLocaleDateString((props.data?.lang == 'en' ? 'en-EN' : 'id-ID'), {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
  }

  const {t} = useTranslation()

  return (
    <>
      {props.type == 'sip' ? (
        <>
          <p className='mb-5' style={{textAlign: 'justify'}}>
            {/* Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna
            proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar{' '}
            <b>{props.data?.produsen}</b> dapat melakukan proses penerbitan dokumen transaksi jual
            beli dengan pembeli tersebut pada kesempatan pertama */}
            {<StyledProne dangerouslySetInnerHTML={{__html: props.data?.footerContent}} />}
          </p>
          <b>PT Pupuk Indonesia (Persero)</b>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <b className='text-decoration-underline'>{props.data?.signername}</b>
          <br />
          <b>{props.data?.singerposition}</b>
        </>
      ) : props.type == 'kontrak' ? (
        <>
          <div className='mt-8'>
            {!['',null,'<p></p>', undefined].includes(props.data?.terms) && (
              <div className='d-flex align-items-start w-100'>
                {props.data?.lang == 'id' ? (
                  <p style={{width: '17%'}}>Syarat dan Ketentuan</p>
                ) : (
                  <p style={{width: '17%'}}>Terms and Conditions</p>
                )}
                <p style={{width: '3%'}}>:</p>
                <p style={{width: '80%'}}>
                  <StyledProne dangerouslySetInnerHTML={{__html: props.data?.terms}} />
                </p>
              </div>
            )}

            {!['',null,'<p></p>', undefined].includes(props.data?.title) && (
              <div className='d-flex align-items-center w-100'>
                {props.data?.lang == 'id' ? (
                  <p style={{width: '17%'}}>Judul</p>
                ) : (
                  <p style={{width: '17%'}}>Title</p>
                )}
                <p style={{width: '3%'}}>:</p>
                <p style={{width: '80%'}}>{props.data?.title}</p>
              </div>
            )}

            <div className='d-flex align-items-center w-100'>
              {props.data?.lang == 'id' ? (
                <p style={{width: '17%'}}> Jangka Waktu Kontrak</p>
              ) : (
                <p style={{width: '17%'}}>Term of the Contract</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                {dateFrom} {props.data?.lang == 'id' ? 's.d' : 'until'} {dateTo}
              </p>
            </div>

            {props.data?.port != '' && (
              <div className='d-flex align-items-center w-100'>
                {props.data?.lang == 'id' ? (
                  <p style={{width: '17%'}}>Tujuan</p>
                ) : (
                  <p style={{width: '17%'}}>Port of Discharge</p>
                )}
                <p style={{width: '3%'}}>:</p>
                <p style={{width: '80%'}}>{props.data?.port}</p>
              </div>
            )}

            {props.data?.segment && (
              <div className='d-flex align-items-center w-100'>
                  <p style={{width: '17%'}}>{t('Sektor')}</p>
                  <p style={{width: '3%'}}>:</p>
                  <p style={{width: '80%'}}>{props.data?.segment?.replace("Sektor ", "")}</p>
              </div>
            )}

            {!['',null,'<p></p>', undefined].includes(props.data?.lain_lain) && (
              <div className='d-flex align-items-start w-100'>
                {props.data?.lang == 'id' ? (
                  <p style={{width: '17%'}}>Lain-lain</p>
                ) : (
                  <p style={{width: '17%'}}>Other</p>
                )}
                <p style={{width: '3%'}}>:</p>
                <p style={{width: '80%'}}>
                  {<StyledProne dangerouslySetInnerHTML={{__html: props.data?.lain_lain}} />}
                </p>
              </div>
            )}
          {(!['null', null, '', '<p></p>', undefined].includes(props.data.keterangan)) ? (
            <>
              <br />
              <StyledProne dangerouslySetInnerHTML={{__html: props.data?.keterangan}} />
            </>
          ) : (
            <p>
              <br />
              <div dangerouslySetInnerHTML={createMarkup2()} />
          </p>
          )}
          </div>
          <div className='mt-5 d-flex justify-content-between'>
            <div>
              {(!['null', null, '', '<p></p>', undefined].includes(props.data?.textPenutup)) ? (
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.textPenutup}} />
              ) : (
                <>
                  {props.data?.lang == 'id' ? (
                    <p>Demikian kami sampaikan, atas perhatiannya diucapkan terima kasih</p>
                  ) : (
                    <p>Best regards, thank you for your attention</p>
                  )}
                </>
              )}
              <br />
              <p>{props.data?.lang == 'id' ? 'Salam Hormat,' : 'Your sincerely,'}</p>
              <b>{props.data?.anper}</b>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <b className='text-decoration-underline'>{props.data?.signername}</b>
              <br />
              <b>{props.data?.singerposition}</b>
            </div>
            <div>
              {props.data?.cusName != '' && props.data?.cusPos != '' ? (
                <>
                  <br />
                  <br />
                  <p>{props.data?.lang == 'id' ? 'Dikonfirmasi,' : 'Confirmed,'}</p>
                  <b>{props.data?.customer}</b>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <b className='text-decoration-underline'>{props.data?.cusName}</b>
                  <br />
                  <b>
                    <StyledProneMbNo dangerouslySetInnerHTML={{__html: props.data?.cusPos}} />
                  </b>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <img
            src={toAbsoluteUrl(props?.data?.imgFooter)}
            style={{width: '100%', height: 'auto', objectFit: 'cover'}}
            alt='media'
          />
        </>
      ) : props.type == 'so' ? (
        <div className='mt-8'>
          {props.data?.typetTransport != '' && (
            <div className='d-flex align-items-center w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Alat Angkut</p>
              ) : (
                <p style={{width: '17%'}}>Transport</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                {
                  [
                    props.data?.typeTransport,
                    props.data?.transport
                  ].filter((x) => x).join(" - ")
                }
              </p>
            </div>
          )}
          {props.data?.etaTransport != '' && (
            <div className='d-flex align-items-center w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>
                  <span className='fst-italic'>ETA </span> Alat Angkut
                </p>
              ) : (
                <p style={{width: '17%'}}>
                  <span className='fst-italic'>ETA </span>Transport
                </p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>{props.data?.etaTransport}</p>
            </div>
          )}
          {props.data?.port != '' && (
            <div className='d-flex align-items-center w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Tujuan</p>
              ) : (
                <p style={{width: '17%'}}>Port of Discharge</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>{props.data?.port}</p>
            </div>
          )}
          {props.data?.portLoading != '' && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Pelabuhan Muat</p>
              ) : (
                <p style={{width: '17%'}}>Port of Loading</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.portLoading}} />
              </p>
            </div>
          )}
          {props.data?.custgroup != '' && (
            <div className='d-flex align-items-center w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Sektor</p>
              ) : (
                <p style={{width: '17%'}}>Sector</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>{custSectorType[props.data?.custgroup]}</p>
            </div>
          )}
          {props.data?.kontrakNum != '' && (
            <div className='d-flex align-items-center w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>No. Kontrak</p>
              ) : (
                <p style={{width: '17%'}}>Contract Number</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>{props.data?.kontrakNum}</p>
            </div>
          )}
          {props.data?.sailing != '' && (
            <div className='d-flex align-items-center w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Tanggal Berangkat</p>
              ) : (
                <p style={{width: '17%'}}>Sailing Date</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>{props.data?.sailing}</p>
            </div>
          )}
          {!['',null,'<p></p>', undefined].includes(props.data?.bast) && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>
                  Teks Tambahan <span className='fst-italic'>BAST</span>
                </p>
              ) : (
                <p style={{width: '17%'}}>Additional Text BAST</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.bast}} />
              </p>
            </div>
          )}
          {props.data?.sales != '' && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Divisi Penjualan</p>
              ) : (
                <p style={{width: '17%'}}>Sales Division</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.sales}} />
              </p>
            </div>
          )}
          {props.data?.picSales != '' && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>
                  <span className='fst-italic'>PIC </span>Divisi Penjualan
                </p>
              ) : (
                <p style={{width: '17%'}}>
                  <span className='fst-italic'>ETA </span>Sales Division
                </p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.picSales}} />
              </p>
            </div>
          )}
          {/* {props.data?.term != '' && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Syarat dan Ketentuan</p>
              ) : (
                <p style={{width: '17%'}}>Terms and Conditions</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.term}} />
              </p>
            </div>
          )}
          {props.data?.termSi != '' && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Syarat dan Ketentuan SI</p>
              ) : (
                <p style={{width: '17%'}}>Terms and Conditions SI</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.termSi}} />
              </p>
            </div>
          )} */}
          {!['',null,'<p></p>', undefined].includes(props.data?.ref) && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>Referensi</p>
              ) : (
                <p style={{width: '17%'}}>Reference</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.ref}} />
              </p>
            </div>
          )}
          {props.data?.tanggalShip != '' && (
            <div className='d-flex align-items-center w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>
                  Tanggal <span className='fst-italic'>Shipping Instruction</span>
                </p>
              ) : (
                <p style={{width: '17%'}}>Shipping Instruction Date</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>{props.data?.tanggalShip}</p>
            </div>
          )}
          {!['',null,'<p></p>', undefined].includes(props.data?.inv) && (
            <div className='d-flex align-items-start w-100'>
              {props.data.lang == 'id' ? (
                <p style={{width: '17%'}}>
                  Catatan <span className='fst-italic'>Invoice</span>
                </p>
              ) : (
                <p style={{width: '17%'}}>Invoice Notes</p>
              )}
              <p style={{width: '3%'}}>:</p>
              <p style={{width: '80%'}}>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data?.inv}} />
              </p>
            </div>
          )}
          <br />
          {props.data.lang == 'id' ? (
            <p>
              Produk tersebut harap diambil di plant yang telah ditentukan paling lambat{' '}
              {validDate()}
            </p>
          ) : (
            <p>
              Please be picked up a product at the plant at the latest {validDate()}
            </p>
          )}
          <br />

          <p>
            {props.data?.textPenutup && (
              <StyledProne dangerouslySetInnerHTML={{__html: props.data?.textPenutup}} />
            )}
          </p>
          <br />

          {(!['null', null, '', '<p></p>', undefined].includes(props.data.keterangan)) ? (
            <StyledProne dangerouslySetInnerHTML={{__html: props.data?.keterangan}} />
          ) : (
            <p>
              <div dangerouslySetInnerHTML={createMarkup2()} />
           </p>
          )}
          <br />

          {props.data.lang == 'id' ? (
            <p>Demikian disampaikan, atas perhatiannya diucapkan terima kasih.</p>
          ) : (
            <p>Best regards, thank you for your attention</p>
          )}
          <div className='d-flex justify-content-between'>
            <div>
              <br />
              <b>{props.data?.salesorgname}</b>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <b className='text-decoration-underline'>{props.data?.signername}</b>
              <br />
              <b>{props.data?.singerposition}</b>
            </div>
            <div>
              { props.data?.cusName && (
                <>
                  <br />
                  <b>{props.data?.customer}</b>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <b className='text-decoration-underline'>{props.data?.cusName}</b>
                  <br />
                  <b>
                    <StyledProneMbNo dangerouslySetInnerHTML={{__html: props.data?.cusPosition}} />
                  </b>
                </>
              ) }
            </div>
          </div>
          <br />
          <img
            src={toAbsoluteUrl(props?.data?.imgFooter)}
            style={{width: '100%', height: 'auto', objectFit: 'cover'}}
            alt='media'
          />
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default React.memo(Footer)
